import Service, { service } from '@ember/service';

export default class ThemesService extends Service {
  @service store;
  fetched = false;
  results = [];

  get themeOptions() {
    return this.store.peekAll('theme').map((item) => ({
      color: item.color,
      label: item.title,
      value: item.id,
    }));
  }

  async getThemes() {
    if (!this.fetched) {
      const themes = await this.loadThemes();
      this.fetched = true;
      return themes;
    } else {
      return this.store.peekAll('theme');
    }
  }

  async loadThemes() {
    const themes = await this.store.findAll('theme');
    return themes;
  }
}
